// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3sP0A","productName":"Table_productName__3JiXM"};